$(function ($) {
  var scrollContainerSelector = window;

  var $trainingApp = $(".positronic-app.training");

  var aosSettings = {
    offset: 300,
    disable: "mobile",
    duration: 800,
    easing: "ease-in-out",
  };

  // section detection
  var moduleScrollPoints = [];
  var curModuleScrollIndex = 0;
  var moduleScrollInitted = false;
  function setupModuleScroll() {
    if ($.mobile) return;

    var screenH = $(window).height();

    if (!moduleScrollInitted) {
      $("body").addClass("enable-module-scroll");

      $(".lesson-module-wrap").each(function (i, el) {
        var $el = $(el);
        var offsetTop = $el.offset().top;
        var newScrollPoint = {
          $el: $el,
          bgStyle: $el.data("bgStyle"),
          bgColor: $el.data("bgColor"),
          bgImage: $el.data("bgImage"),
        };

        moduleScrollPoints.push(newScrollPoint);
      });

      moduleScrollInitted = true;
    }

    $.each(moduleScrollPoints, function (i, sect) {
      var offsetTop = sect.$el.offset().top;
      moduleScrollPoints[i].top = offsetTop - screenH / 2;
      moduleScrollPoints[i].bottom =
        offsetTop + sect.$el.height() - screenH / 2;
    });
  }

  var lastScrollTop = 0;
  var scrolling = 0;
  function moduleScrollOnScroll() {
    scrolling = $(window).scrollTop();

    console.log(curModuleScrollIndex, scrolling, lastScrollTop);

    var newModuleScrollIndex;
    var nextModuleScrollIndex = curModuleScrollIndex;
    var scrollingDown = scrolling - lastScrollTop > 0;

    if (moduleScrollPoints.length === 0) return;

    if (scrollingDown) {
      while (
        nextModuleScrollIndex < moduleScrollPoints.length &&
        moduleScrollPoints[nextModuleScrollIndex].top <= scrolling
      ) {
        newModuleScrollIndex = nextModuleScrollIndex;
        nextModuleScrollIndex = nextModuleScrollIndex + 1;
      }
    } else {
      while (
        nextModuleScrollIndex >= 0 &&
        moduleScrollPoints[nextModuleScrollIndex].bottom >= scrolling
      ) {
        newModuleScrollIndex = nextModuleScrollIndex;
        nextModuleScrollIndex = nextModuleScrollIndex - 1;
      }
    }

    if (
      newModuleScrollIndex != curModuleScrollIndex &&
      moduleScrollPoints[newModuleScrollIndex]
    ) {
      $("body").removeClass(
        "bg-fade-" + moduleScrollPoints[curModuleScrollIndex].color
      );
      $("body").addClass(
        "bg-fade-" + moduleScrollPoints[newModuleScrollIndex].color
      );

      curModuleScrollIndex = newModuleScrollIndex;

      $trainingApp.trigger(TRAINING_EVENTS.NEW_MODULE, {
        index: newModuleScrollIndex,
        module: moduleScrollPoints[newModuleScrollIndex],
      });
    }

    lastScrollTop = scrolling;
  }

  // on resize
  $(window).on("resize", function () {
    setupModuleScroll();
  });

  // on scroll
  $(window).on("scroll", moduleScrollOnScroll);

  // on init
  AOS.init(aosSettings);

  setupModuleScroll();

  // check initial module
  var initModule;

  if (window.location.hash && window.location.hash.indexOf("module-") > -1)
    initModule = window.location.hash.split("-")[1];
  else if (window.posiLastModule) initModule = window.posiLastModule;

  // trigger init position
  setTimeout(function () {
    if (initModule) {
      $trainingApp.trigger(TRAINING_EVENTS.NEW_MODULE, {
        index: initModule,
        module: moduleScrollPoints[initModule],
      });
      $("body, html").scrollTop(
        $('.lesson-module-wrap[data-id="' + initModule + '"]').offset().top
      );
    }

    moduleScrollOnScroll();
  }, 100);
});
